<template>
  <div>

    <a-switch v-model:checked="checked" @change="checkedChange" />
    <p style="margin-top: 20px;">是否开启邮寄模式，注：系统没有物流模式，请商家自行发货并在“兑换订单”里面附上快递单号供顾客查询</p>

    <a-button
      type="primary"
      :style="{ margin: '0 0 24px 0' }"
      @click="showModal"
    >
      新增
    </a-button>
    <a-modal
      :width="820"
      centered
      v-model="visible"
      title="新增商品"
      @ok="handleAdd"
      :maskStyle="{ opacity: 0.1 }"
      cancelText="取消"
      okText="确定"
    >
      <a-form
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 13 }"
      >
        <a-form-item
          label="商品分类"
          labelAlign="left"
        >
          <a-select
            default-value=""
            @change="handleChange"
            placeholder="请选择商品分类"
            style="display: block"
            v-model="addGoods.categoryId"
          >
            <a-select-option :value="item.objId" v-for="(item,index) in categoryListA" :key="index"> {{item.categoryName}} </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          label=" 商品名称"
          labelAlign="left"
        >
          <a-input placeholder="请输入商品名称" v-model="addGoods.goodsName" />
        </a-form-item>
        <a-form-item
          label=" 商品数量"
          labelAlign="left"
        >
          <a-input placeholder="请输入商品数量" v-model="addGoods.goodsQuantity" />
        </a-form-item>
        <a-form-item
          label="兑换商品数量"
          labelAlign="left"
        >
          <a-input placeholder="请输入兑换商品数量" v-model="addGoods.saleQuantity" />
        </a-form-item>
        <a-form-item
          label=" 所需彩票数量"
          labelAlign="left"
        >
          <a-input placeholder="请输入所需彩票数量" v-model="addGoods.lotteryQuantity" />
        </a-form-item>
        <a-form-item
          label="所属门店id"
          labelAlign="left"
          v-if="false"
        >
          <a-input placeholder="请输入所属门店id" v-model="addGoods.shopId" />
        </a-form-item>
        <a-form-item
          label="所属门店名称"
          labelAlign="left"
          v-model="addGoods.shopName"
          v-if="false"
        >
          <a-input placeholder="请输入所属门店名称" />
        </a-form-item>
        <a-form-item
          label="兑换地址"
          labelAlign="left"

        >
          <a-input placeholder="请输入兑换地址"  v-model="addGoods.address"/>
        </a-form-item>
        <a-form-item
          label="字段排序"
          labelAlign="left"
        >
          <a-input placeholder="请输入字段排序" v-model="addGoods.sortNum" />
        </a-form-item>
        <a-form-item
          label="是否上架"
          labelAlign="left"
        >
          <a-switch
            style="margin-left: 10px"
            v-model="addGoods.isSold"
            checked-children="上架"
            un-checked-children="下架"
            default-checked
            @change="onChanges"
          />
        </a-form-item>
        <a-form-item
          label="上传封面图片"
          labelAlign="left"
        >
            <a-upload
              :fileList="defaultFileList"
              :customRequest="upload"
              :remove="handleFileRemove"
            >
              <a-button> <a-icon type="upload" /> Upload </a-button>
              <span style="color: red">tips：图片大小宽高比1/1.2-1.6</span>
            </a-upload>
        </a-form-item>

      </a-form>
    </a-modal>
    <a-modal
      :width="820"
      centered
      v-model="visibleEdit"
      title="编辑商品选择器"
      @ok="handleOkEdit"
      :maskStyle="{ opacity: 0.1 }"
      cancelText="取消"
      okText="确定"
    >
      <div class="model-search">
        <a-input class="s-input" v-model="name" placeholder="搜索商品名称" />
        <a-button class="s-btn" type="primary" @click="query">查询</a-button>
        <a-button class="s-btn" @click="reset">重置</a-button>
      </div>
      <div class="card">
        <a-card
          class="cards"
          :title="results[index].categoryName1"
          style="width: 250px; height: 180px"
          v-for="(item, index) in results"
          :key="index"
          @click="details(item, index)"
          :class="{ active: currentIndex === index }"
        >
          <img :src="results[index].imgUrl" alt="" />
          <h4 class="text">{{ results[index].skuName }}</h4>
          <span class="text2">{{ results[index].categoryName1 }}</span>
        </a-card>
      </div>
      <a-button @click="next">下一页</a-button>
      <div style="display: flex">
        <div class="a-inputs">
          <p class="show-p">兑换所需彩票</p>
          <a-input
            class="show-input"
            v-model="formInline.lotteryQuantity"
            placeholder="请输入"
          />
        </div>
        <div class="a-inputs">
          <p class="show-p rigths">价格</p>
          <a-input
            class="show-input"
            v-model="formInline.goodsPrice"
            placeholder="请输入"
          />
        </div>
      </div>
      <div style="display: flex">
        <div class="a-inputs">
          <p class="show-p">兑换地址</p>
          <a-input
            class="show-input"
            v-model="formInline.address"
            placeholder="请输入"
          />
        </div>
        <div class="a-inputs">
          <p class="show-p rigths">商品数量</p>
          <a-input
            class="show-input"
            v-model="formInline.goodsQuantity"
            placeholder="请输入"
          />
        </div>
      </div>
      <div class="a-inputs">
        <p class="show-p">是否上下架</p>
        <a-switch
          style="margin-left: 10px"
          v-model="formInline.isSold"
          checked-children="上架"
          un-checked-children="下架"
          default-checked
          @change="(val) => {val ? formInline.isSold = 1 : formInline.isSold = 0}"
        />
      </div>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="name" slot-scope="name">
        {{ name.first }} {{ name.last }}
      </template>
      <template slot="pic" slot-scope="name">
        <img :src="name" alt="" />
      </template>
      <a-avatar slot="avatar" icon="user" />
      <span slot="memberStatus" slot-scope="text, memberStatus">
        <a-switch
          checked-children="上架"
          un-checked-children="下架"
          :checked="memberStatus.isSold === 1 ? true : false"
          @change="onChange(memberStatus)"
        />
      </span>
      <template slot="operate" slot-scope="text, operate">
        <a href="javascript:;" @click="edit(operate)">编辑</a>
        <a href="javascript:;" @click="del(operate)">删除</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  categoryList,
  mallAdd,
  ExchangeList,
  addGoodsList,
  addExchangeList,
  editExchangeList,
  delExchangeList,
  addGoodsListSeach,
  addGoodsListNext,
  storeExchangessss,
  picUpload,  
  storeGetMailSwitch,
  storeEditMailSwitch,

} from "@/api/storeApi.js";
import { message } from "ant-design-vue";
import { mapState } from "vuex";
const columns = [
  {
    title: "编号",
    dataIndex: "objId",
    scopedSlots: { customRender: "objId" },
  },
  {
    title: "商品名称",
    align: "center",
    dataIndex: "goodsName",
  },
  {
    title: "封面图",
    dataIndex: "imageUrl",
    align: "center",
    scopedSlots: { customRender: "pic" },
  },
  {
    title: "兑换所需彩票",
    dataIndex: "lotteryQuantity",
    align: "center",
    scopedSlots: { customRender: "lotteryQuantity" },
  },
  {
    title: "所属门店",
    dataIndex: "shopName",
    align: "center",
    scopedSlots: { customRender: "shopName" },
  },
  {
    title: "上下架",
    dataIndex: "isSold",
    align: "center",
    scopedSlots: { customRender: "memberStatus" },
  },
  {
    title: "已兑换数量",
    align: "center",
    dataIndex: "saleQuantity",
    scopedSlots: { customRender: "saleQuantity" },
  },
  {
    title: "兑换地址",
    dataIndex: "address",
    align: "center",
    scopedSlots: { customRender: "address" },
  },
  {
    title: "显示序号",
    dataIndex: "sortNum",
    align: "center",
    scopedSlots: { customRender: "sortNum" },
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    align: "center",
    scopedSlots: { customRender: "createTime" },
  },
  {
    title: "操作",
    dataIndex: "operate",
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      defaultFileList: [],
      addGoods:{
        saleQuantity:"",
        categoryId:"",
        goodsName:"",
        lotteryQuantity:"",
        shopId:sessionStorage.getItem('shopId'),
        isSold:true,
        address:''
      },
      name: "",
      scrollId: "",
      flags: false,
      results: [],
      flag: false,
      goods: "",
      address: "",
      goodsName: "",
      goodsPrice: "",
      goodsQuantity: "",
      imageUrl: "",
      isSold: 1,
      jdGoodsId: "",
      lotteryQuantity: "",
      sortNum: "",
      data: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
      visibleEdit: false,
      formInline: {
        id: "",
        address: "",
        goodsName: "",
        goodsPrice: "",
        goodsQuantity: "",
        imageUrl: "",
        isSold: 1,
        jdGoodsId: "",
        lotteryQuantity: "",
        sortNum: 0,
      },
      currentIndex: "",
      categoryListA:[],
      checked: false,

    };
  },
  mounted() {
    this.getAddGoodsList();
    this.getExchangeList();
    this.loadCatList();
    this.getShopIcon();
  },
  computed:{
  },
  props: ["exchange"],
  methods: {
    getShopIcon(){
      storeGetMailSwitch().then(res => {
        this.checked = res.data.isUse === 1 ? true : false;
      });
    },
    async checkedChange() {
      const isUse = this.checked ? 1 : 0;
      this.loading = true;
      const res = await storeEditMailSwitch({isUse: isUse});
      if(res.success){
        this.getShopIcon();
      } else {
        // 如果更新失败，可以考虑提示用户或回滚状态
        message.error('更新失败,显示状态回滚');
        this.checked = !this.checked;
      }
      this.loading = false;
    },
    loadCatList(){
      categoryList({ limit: 30, page: 1 }).then(res=>{
        this.categoryListA = res.data;
      })
    },
    upload(file) {
      // file是上传的文件
      const file_size = file.file.size;
      if (file_size > this.$file_max_size) {
        message.error("请确保图片大小在2M以内");
        return false;
      }
      const form = new FormData();
      form.append("file", file.file);
      form.append("contractName", file.file.name);
      form.append("description", file.file.name);
      picUpload(form)
        .then((res) => {
          if(res.code == '0000') {
            this.addGoods.imageUrl= res.data;
            file.onSuccess(res, file);
            message.success("上传成功");
            this.defaultFileList.push({
              uid: file.file.uid,
              name: file.file.name,
              status: "done",
              url: res.data,
            });
          }else {
            file.onError(res, file);
            message.error(res.info);
          }
        })
        .catch((err) => {
          message.error("请确保图片大小在2M以内");
        });
    },
    handleFileRemove (file) {
      const name = file.name
      this.defaultFileList = this.defaultFileList.filter(item => {
        if (name !== item.name) return item
      })
      console.log(this.defaultFileList)
    },
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      ExchangeList({ limit: 10, page: this.pagination.current }).then((res) => {
        this.data = res.data;
        console.log(res);
        this.loading = false;
      });
    },
    handleChange() {},
    del(row) {
      this.loading = true;
      console.log(row);
      delExchangeList(row.objId).then((res) => {
        this.loading = false;
        message.success(res.data);
        this.getExchangeList();
      });
    },
    query() {
      if (this.name !== "") {
        addGoodsListSeach(this.name).then((res) => {
          this.results = res.data.entries;
          this.scrollId = res.data.scrollId;
        });
      } else {
        message.warning("商品名称不可为空");
      }
      console.log(this.skuName, "asdasdsa");
    },
    reset() {
      this.name = "";
      addGoodsList().then((res) => {
        this.results = res.data.entries;
        this.scrollId = res.data.scrollId;
        console.log(res);
      });
    },
    next() {
      addGoodsListNext(this.scrollId).then((res) => {
        this.results = res.data.entries;
      });
    },
    seach() {
      this.loading = true;
      ExchangeList(this.exchange).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.pagination.total = res.count;
      });
    },
    //,
    onChange(row) {
      if (row.isSold === 1) {
        storeExchangessss(row.objId, 0).then((res) => {
          this.getExchangeList();
          message.success(res.data);
        });
      } else {
        storeExchangessss(row.objId, 1).then((res) => {
          this.getExchangeList();
          message.success(res.data);
        });
      }
    },
    onChanges(value) {
      if (value === false) {
        this.isSold = 0;
      }
    },
    getExchangeList() {
      ExchangeList({ limit: 10, page: 1 }).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    getAddGoodsList() {
      addGoodsList().then((res) => {
        this.results = res.data.entries;
        this.scrollId = res.data.scrollId;
        console.log(res);
      });
    },
    details(res, index) {
      let card = res;
      this.currentIndex = index;
      console.log(index, "card");
      this.goodsName = res.brandName;
      this.imageUrl = res.imgUrl;
      this.jdGoodsId = res.skuId;

      this.formInline.goodsName = res.brandName;
      this.formInline.imageUrl = res.imgUrl;
      this.formInline.jdGoodsId = res.skuId;
    },
    edit(row) {
      console.log(row);
      this.visibleEdit = true;
      this.formInline = row;
      this.formInline.id = row.objId;
    },
    //
    showModal() {
      this.visible = true;
      this.defaultFileList = []
    },
    handleOk() {
      this.visible = false;
      addExchangeList({
        lotteryQuantity: this.lotteryQuantity,
        goodsQuantity: this.goodsQuantity,
        goodsPrice: this.goodsPrice,
        address: this.address,
        goodsName: this.goodsName,
        isSold: this.isSold,
        imageUrl: this.imageUrl,
        jdGoodsId: this.jdGoodsId,
        sortNum: 0,
      }).then((res) => {
        if (res.code === "0000") {
          message.success(res.data);
          this.getExchangeList();
          this.lotteryQuantity = "";
          this.goodsQuantity = "";
          this.goodsPrice = "";
          this.address = "";
          this.goodsName = "";
          this.imageUrl = "";
          this.jdGoodsId = "";
          this.sortNum = "";
        } else {
          message.warning(res.info);
        }
      });
    },
    handleOkEdit() {
      this.visibleEdit = false;
      this.loading = true;
      editExchangeList(this.formInline).then((res) => {
        this.loading = false;
        this.getExchangeList();
        message.success(res.info);
      });
    },
    handleAdd(){
      // addGoods:{
      //   objId:"",
      //     goodsName:"",
      //     lotteryQuantity:"",
      //     shopId:sessionStorage.getItem('shopId'),
      //     isSold:false,
      //     address:''
      if(!this.addGoods.categoryId){
        message.error("请选择商品分类");
        return
      }
      if(!this.addGoods.goodsName){
        message.error("请输入商品名称");
        return
      }
      if(!this.addGoods.lotteryQuantity){
        message.error("请输入商品数量");
        return
      }
      if(!this.addGoods.address){
        message.error("请输入兑换地址");
        return
      }
      if(!this.addGoods.saleQuantity){
        message.error("请输入兑换商品数量");
        return
      }
      if(!this.addGoods.imageUrl){
        message.error("请上传封面图片");
        return
      }
      let  flag =this.addGoods.isSold ? 1:0
      let form ={...this.addGoods}
      form.isSold = flag
      form.goodsPrice = form.lotteryQuantity;
      form.shopId = sessionStorage.getItem('shopId'),
      mallAdd(form).then(res=>{
          Object.keys(this.addGoods).forEach(key=>{
            this.addGoods[key] = ''
            this.visible =false
          })
        message.success('添加成功');
        this.handleTableChange(this.pagination)
      }).catch(e=>{
        message.error('添加失败');
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.text {
  position: relative;
  left: 90px;
  bottom: 80px;
}

.text2 {
  position: relative;
  left: 90px;
  bottom: 60px;
}

.details {
  display: flex;
}

img {
  width: 80px;
  height: 80px;
}

.a-inputs {
  display: flex;
}
.show-input {
  width: 250px;
}
.show-p {
  text-align: center;
  height: 32px;
  line-height: 32px;
  width: 100px;
}

.model-search {
  display: flex;
  margin-bottom: 20px;
}

.s-input {
  width: 400px;
  margin: 0 20px;
}

.s-btn {
  margin: 0 20px;
}

.card {
  width: 780px;
  display: flex;
  margin-top: 20px;
  flex-wrap: wrap;
  position: relative;
  right: 5px;
}

.cards {
  margin: 5px;
}

.active {
  border: 1px solid rgb(21, 105, 214);
}

.none {
  border: 1px solid #000;
}

.text {
  width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
  ::v-deep .ant-select-selection__placeholder{
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/views/marketingManagement/exchangeManagement/exchangeManagementContent.vue